import React from 'react'
import { View } from 'react-native'
import type { OptionColor } from '@order/steps/types'
import Status from '@ui/elements/Status'
import { colorOptionToColors } from './styles'

interface Props {
  text: string
  colorOption?: OptionColor // TODO: get this value from context instead
}

export default function OptionLabel({ text, colorOption = 'default' }: Props) {
  return (
    <View className="absolute -top-3 left-8 rounded-lg border-4 border-white">
      <Status text={text} colors={colorOptionToColors[colorOption]} />
    </View>
  )
}
